import {
  ActionIcon,
  Avatar,
  Box,
  Center,
  Grid,
  Group,
  Paper,
  ScrollArea,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { getHotkeyHandler } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import moment from "moment/moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Send, X } from "tabler-icons-react";
import InputField from "../../../components/inputField";
import { LoaderWrapper } from "../../../components/LoaderWrapper";
import { axiosGet, axiosPost, userData } from "../../../Helpers";
import { loadMessagesData } from "./loadData";
import "./style.css";

const Index = () => {
  const [selectedUser, setSelectedUser] = useState({});
  const [conversationLoader, setConversationLoader] = useState(false);
  const [allConversationsLoader, setAllCoversationsLoader] = useState(true);
  const [sendMessageLoader, setSendMessageLoader] = useState(false);
  const [allConversations, setAllConversations] = useState([]);
  const [conversations, setConversations] = useState([]);

  const [chatRefresh, setChatRefresh] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [refresh, setRefresh] = useState(false);

  const [searchPhrase, setSearchPhrase] = useState("");
  const [searchedChats, setSearchedChats] = useState([]);

  const search = (event) => {
    if (event.target.value !== "") {
      setSearchedChats(
        searchedChats.filter((data) => {
          if (
            data.displayName
              .toLowerCase()
              .includes(event.target.value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      );
      setSearchPhrase(event.target.value);
    } else {
      setSearchedChats(allConversations);
      setSearchPhrase(event.target.value);
    }
  };
  useEffect(() => {
    loadMessagesData(setAllCoversationsLoader).then(setAllConversations);
    loadMessagesData(setAllCoversationsLoader).then(setSearchedChats);
  }, [refresh]);
  useEffect(() => {}, [conversations.toUserId]);
  useEffect(() => {}, [chatRefresh]);

  const handleSendMessage = async () => {
    setSendMessageLoader(true);
    try {
      let apiResponse = await axiosPost(`chat/sendMessage`, {
        fromUserId: userData.id,
        toUserId: selectedUser.toUserId,
        message: chatMessage,
      });
      if (apiResponse.data.status) {
        setRefresh(!refresh);
        setSendMessageLoader(false);
        setChatMessage("");
        setChatRefresh(!chatRefresh);
        loadConversations(selectedUser);
      } else {
        console.log("error");
        setSendMessageLoader(false);
        setChatMessage("");
      }
      console.log(apiResponse, "apiResponse");
    } catch (e) {
      setSendMessageLoader(false);
      setChatMessage("");
      console.log(e);
    }
  };

  // useEffect(() => {
  //   if (selectedUser.conversationId) {
  //     loadConversations();
  //   }
  // }, []);
  const loadConversations = async (selectedUser) => {
    if (selectedUser?.conversationId) {
      let apiResponse = await axiosGet(
        `chat/getSingleConversation/${selectedUser.conversationId}`
      );
      console.log(apiResponse, "apiResponse");
      if (apiResponse.data.status) {
        setConversations(apiResponse.data.data);
        setConversationLoader(false);
        setChatRefresh(!chatRefresh);
      } else {
        setConversationLoader(false);
      }
    } else {
      showNotification({
        title: "No conversation selected",
        message: "Please select a conversation to start chatting",
        color: "red",
      });
    }
  };

  return (
    <LoaderWrapper loading={allConversationsLoader}>
      <Paper
        style={{ height: "100%", width: "100%" }}
        bg={"transparent"}
        withBorder
      >
        <Grid p={"md"} style={{ height: "100%", width: "100%" }}>
          <Grid.Col base={6} xs={6} sm={6} md={6} lg={5} xl={4}>
            <Title my={"sm"} order={1} className="text-dark text-center">
              Conversations
            </Title>

            <TextInput
              size="lg"
              placeholder="Search"
              value={searchPhrase}
              onChange={search}
              label="Search conversation"
            />
            <Stack my={"md"}>
              {searchedChats
                ?.sort((a, b) => {
                  let fa = a.displayName.toLowerCase(),
                    fb = b.displayName.toLowerCase();

                  if (fa < fb) {
                    return -1;
                  }
                  if (fa > fb) {
                    return 1;
                  }
                  return 0;
                })
                .map((user, index) => {
                  return (
                    <Box
                      sx={(theme) => ({
                        ":hover": {
                          backgroundColor: theme.colors.red[7],
                          color: theme.white,
                        },
                        backgroundColor:
                          user.conversationId === selectedUser.conversationId
                            ? theme.colors.red[8]
                            : "",
                        color:
                          user.conversationId === selectedUser.conversationId
                            ? theme.white
                            : theme.black,
                        border: `1px solid ${theme.colors.red[9]}`,
                        borderRadius: theme.spacing.xs,
                        padding: theme.spacing.md,
                      })}
                      key={index}
                      onClick={() => {
                        console.log("This is the selected user: ", user);
                        setSelectedUser(user);
                        setConversationLoader(true);
                        loadConversations(user);
                      }}
                    >
                      <Group noWrap position="apart">
                        <Group noWrap>
                          <Avatar size={"lg"} radius={"xl"} src={user?.image} />
                          <Title order={4} style={{}}>
                            {user.displayName}
                          </Title>
                        </Group>
                        <Text>{moment(user?.sendDate).format("LL")}</Text>
                      </Group>
                    </Box>
                  );
                })}
            </Stack>
          </Grid.Col>
          <Grid.Col
            style={{ borderLeft: "1px solid #eaeaea" }}
            base={6}
            xs={6}
            sm={6}
            md={6}
            lg={7}
            xl={8}
          >
            {selectedUser?.conversationId ? (
              <>
                <Group position="apart">
                  <Group>
                    <Avatar
                      size={"lg"}
                      radius={"xl"}
                      src={selectedUser?.image || "Image"}
                    />
                    <Title order={3} className="text-dark d-flex">
                      {selectedUser?.displayName || "User"}
                    </Title>
                  </Group>
                  <ActionIcon
                    variant="filled"
                    color={"red.8"}
                    onClick={() => {
                      setSelectedUser({});
                    }}
                  >
                    <X />
                  </ActionIcon>
                </Group>
                <Stack>
                  <LoaderWrapper loading={conversationLoader}>
                    <Paper
                      p={"xs"}
                      withBorder
                      component={ScrollArea}
                      style={{ height: "65vh" }}
                    >
                      {conversations?.map((conversation, index) => {
                        return (
                          <Group
                            key={index}
                            position={
                              conversation.fromUserId._id === userData.id
                                ? "right"
                                : "left"
                            }
                            spacing={3}
                          >
                            <Stack
                              my={3}
                              bg={"red.8"}
                              style={{
                                borderRadius: "5px",
                                padding: "1rem",
                                maxWidth: "250px",
                                color: "white",
                              }}
                            >
                              <Text size={"lg"}>{conversation?.message}</Text>
                              <Text size={"sm"} align={"right"}>
                                {moment(conversation.createdDate).format("LL")}
                              </Text>
                            </Stack>
                          </Group>
                        );
                      })}
                    </Paper>
                  </LoaderWrapper>

                  <TextInput
                    value={chatMessage}
                    size="lg"
                    placeholder="Type your message"
                    onKeyDown={getHotkeyHandler([["enter", handleSendMessage]])}
                    onChange={(e) => {
                      setChatMessage(e.target.value);
                    }}
                    label="Type your message"
                    rightSection={
                      <ActionIcon
                        loading={sendMessageLoader}
                        onClick={handleSendMessage}
                      >
                        <Send />
                      </ActionIcon>
                    }
                  />
                </Stack>
              </>
            ) : (
              <Center>
                <Title>Select A Chat to Continue</Title>
              </Center>
            )}
          </Grid.Col>
        </Grid>
      </Paper>
    </LoaderWrapper>
  );
};

export default Index;
